<script>
import gui from '@/mixins/admin/gui';

export default {
  mixins: [gui],
  template: '<div></div>',
};
</script>
